import { useLanguage } from '../../contexts/LanguageContext';
import { useData } from '../../contexts/DataContext';
import { useMediaQuery } from 'react-responsive';
import AboutDesk from '../../components/Desktop/AboutDesktop';
import AboutMob from '../../components/Mobile/AboutMobile';

const About = () => {
  const { language } = useLanguage();
  const result = useData();
  const about = result.data.about;
  const isMobile = useMediaQuery({ minWidth: 0, maxWidth: 768 });

  const sharedProps = {
    about,
    language
  };

  return isMobile ? <AboutMob {...sharedProps} /> : <AboutDesk {...sharedProps} />;
};

export default About;